export const DEFAULT_REFUND_POLICY = `All ticket sales are final. Refunds are only issued if the event is cancelled or rescheduled by the organizer.

If the event is cancelled, ticket holders will receive a full refund to the original payment method within 5–10 business days.

If the event is rescheduled, tickets remain valid for the new date. Refund requests for rescheduled events must be submitted at least 48 hours before the original event start time.

For questions about refunds, contact the event organizer before the event date.`;
